import s from './style.css';
import Chapter from 'components/Chapter';
import TextWithBackground from 'components/TextWithBackground';
import {
	title,
	standfirst,
	miniTitle,
	miniDesc,
	sectionIntro,
	sections,
	fact
} from 'copy/intro.txt';

const Intro = () => (
	<Chapter onRight>
		<div className={s.wrap}>
			<div className={s.beginArrow} />

			<h1 className={s.title}>{title}</h1>

			<TextWithBackground className={s.standfirst} tag="p">
				{standfirst}
			</TextWithBackground>

			<div className={s.descContainer}>
				<p className={s.descWrapper}>
					<span className={s.descName}>{miniTitle}</span>
					<span className={s.descNoun}>{miniDesc}</span>
				</p>

				<TextWithBackground tag="p">{sectionIntro}</TextWithBackground>

				<ul className={s.descriptionCopyContainer}>
					{sections.map(({ emoji, text }) => (
						<TextWithBackground
							data-emoji={emoji}
							tag="li"
							className={s.descriptionCopy}
						>
							{text}
						</TextWithBackground>
					))}
				</ul>
			</div>

			<div className={`${s.beginArrow} ${s.shortArrow}`} />
			<p className={s.introFact}>{fact}</p>
			<div className={s.endArrow} />
		</div>
	</Chapter>
);

export default Intro;



// WEBPACK FOOTER //
// ./components/Intro/index.js